import React from "react";
import BlogFour from "../Menhomefour/BlogFour";
import TestimonialFour from "../Menhomefour/TestimonialFour";
import PartnerThree from "../Menhomefour/PartnerThree";
import PackageOne from "../Menhomefour/PackageOne";
import BussinessGrow from "../Menhomefour/BussinessGrow";
import JoinusTwo from "../Menhomefour/JoinusTwo";
import FeaturesFour from "../Menhomefour/FeaturesFour";
import BannerFour from "../Menhomefour/BannerFour";
import HeaderFour from "../HeaderFour/Main";
import FooterFour from "../FooterFour/Main";

function Main() {
  return (
    <div>
      <HeaderFour />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <main className="site-main">
              <BannerFour />
              <FeaturesFour />
              <JoinusTwo />
              <BussinessGrow />
              <PackageOne />
              <PartnerThree />
              <TestimonialFour />
              <BlogFour />
            </main>
            <FooterFour />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
